import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="not-found">
      <h1>Page not found</h1>
      <p>That page isn’t on this site. Head back to Floro.</p>
      <Link to="/" className="btn-pill">Go to homepage</Link>
    </main>
  );
}
